import React from "react";
import { FiTrash2 } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import "styles/components/TimeIntervalCard.scss";

const TimeIntervalCard = ({
	typeLabel,
	startLabel,
	endLabel,
	typeValue,
	startValue,
	endValue,
	onRemove,
	removeAriaLabel,
}) => {
	const { t } = useTranslation();
	return (
		<div className="time-interval-card">
			<div className="time-interval-card__field">
				<span className="time-interval-card__label">{typeLabel || t("common.type")}</span>
				<strong className="time-interval-card__value">{typeValue}</strong>
			</div>
			<div className="time-interval-card__field">
				<span className="time-interval-card__label">{startLabel || t("common.start")}</span>
				<strong className="time-interval-card__value">{startValue}</strong>
			</div>
			<div className="time-interval-card__field">
				<span className="time-interval-card__label">{endLabel || t("common.end")}</span>
				<strong className="time-interval-card__value">{endValue}</strong>
			</div>
			<div className="time-interval-card__actions">
				<button
					type="button"
					className="btn btn-icon"
					onClick={onRemove}
					aria-label={removeAriaLabel || t("shifts.form.removePeriodAriaLabel")}
				>
					<FiTrash2 />
				</button>
			</div>
		</div>
	);
};

export default TimeIntervalCard;
